import { DataSourceBaseNew } from '@components/new-table/data-source-base-new.dataSource';
import { Injectable } from '@angular/core';
import { DocumentationMmssService, TableDataApiParams } from '@services/documentation-mmss.service';
import { MmssDocumentationModel } from '@/models/tables/mmss-documentation.model';

@Injectable({
  providedIn: 'root',
})
export class MmssDocumentationDataSource extends DataSourceBaseNew<MmssDocumentationModel> {
  constructor(private documentationMmssService: DocumentationMmssService) {
    super();
  }

  loadData(params?: TableDataApiParams): void {
    this._isLoading$.next(true);

    this.documentationMmssService.getDocuments(params).subscribe((data) => {
      if (data && data.content) {
        this.elements$.next(data.content);
        this._totalElements$.next(data.totalElements);
      } else {
        this.elements$.next([]);
        this._totalElements$.next(0);
      }
      this._isLoading$.next(false);
    });
  }
}
